import { useTranslate } from '@va/localization';
import { MultiSelectFilter, TextFilter } from '@va/shared/feature-filters';
import { FilterOperators } from '@va/types/filters';
import { useMemo } from 'react';
import { useBrowserOptions } from '../filter-options';
import { FilterHook } from '../types';

export const useBrowserNameFilter: FilterHook<typeof MultiSelectFilter> = (params) => {
  const translate = useTranslate();

  return useMemo(
    () =>
      new MultiSelectFilter({
        id: 'browserName',
        name: 'browserName',
        label: translate('filter.browserName'),
        operator: FilterOperators.is,
        operatorOptions: [FilterOperators.is, FilterOperators.isNot],
        ...params,
        inputProps: {
          showSearchInput: true,
          searchPlaceholder: translate('filters.placeholder.browserName'),
          useOptions: useBrowserOptions,
          ...params,
        },
      }),
    [params, translate],
  );
};

export const useBrowserVersionFilter: FilterHook<typeof TextFilter> = (params) => {
  const translate = useTranslate();

  return useMemo(
    () =>
      new TextFilter({
        id: 'browserVersion',
        name: 'browserVersion',
        label: translate('filter.browserVersion'),
        operator: FilterOperators.is,
        operatorOptions: [FilterOperators.is, FilterOperators.isNot],
        ...params,
        inputProps: { placeholder: translate('filters.placeholder.browserVersion'), ...params?.inputProps },
      }),
    [params, translate],
  );
};
